import { formatShippingAddress } from '@/components/order/utils';
import { Stack, Typography } from '@montugroup/design-system';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export type ClickAndCollectDetailsProps = {
  pharmacy: {
    name: string;
    address1: string;
    address2: string | null;
    city: string;
    state: string;
    zipCode: string;
  };
};

export function ClickAndCollectDetails(props: ClickAndCollectDetailsProps) {
  const {
    pharmacy: { name, address1, address2, city, state, zipCode },
  } = props;

  return (
    <Stack alignItems={'flex-start'} gap={1}>
      <Stack direction={'row'} alignItems={'center'}>
        <LocationOnIcon sx={(theme) => ({ color: theme.palette.secondary.main })} />
        <Typography variant="overline" lineHeight="1.3">
          COLLECT AT
        </Typography>
      </Stack>
      <Typography variant="body2" fontWeight="bold">
        {name}
      </Typography>
      <Typography variant="body2">
        {formatShippingAddress({ address1, address2, city, zip: zipCode, province: state })}
      </Typography>
    </Stack>
  );
}
